<template>
  <v-app v-if="appView">
    <v-content>
      <router-view/>
    </v-content>
    <v-footer class="blue darken-1" app dark>
      <div>{{$moment().format("YYYY")}} — v. 1.0.0</div>
    </v-footer>
  </v-app>
</template>

<script>
import jwtDecode from "jwt-decode";

export default {
  name: 'App',
  data () {
    return {
      //Caso o usuário não esteja logado ele não conseguirá ver nada na aplicação
      appView: true,
      manutencoesAtivas: null
    }
  },
  methods:{
    //Verifica se o usuário está logado
    checkToken () {
    let token = localStorage.getItem('token')

      if(token == null || token == "") {
        //Redireciona para página de Login caso o usuário não tenha permissão de acesso.
        if (this.$route.path == '/' || this.$route.name == 'ConfirmarCadastro' || this.$route.name == 'AlunoInfo' ) {
          localStorage.getItem('token')
        } else {
          this.appView = false
          this.axios.get('user').then(() => {
          }).catch(e => {
            if (e.response.status == 401) {
              alert("Faça login para poder acessar o sistema")
              location.href = "/"
              this.appView = true
            }
          })
        }
      }else{
        this.getManutencaoAtiva()
      }
    },
    perfilUser(){
      return jwtDecode(localStorage.getItem('token'))
    },
    getManutencaoAtiva(){
      this.axios.get('admin/servicos').then(res => {
        this.manutencoesAtivas = res.data
        if(this.manutencoesAtivas != ''){
          if(this.$route.path != '/manutencao' && this.perfilUser().datacom) {
            localStorage.getItem('token')
          }else if(this.$route.path != '/manutencao' ){
              location.href="/manutencao"
          }
        }
      }).finally(() => {
        this.progress = false
      })
    }
  },
  mounted(){
    this.checkToken()

  }
}
</script>

<style>
  html, body{
    height: 100%;
  }

  .page{
    height: 100%;
  }
</style>
